export const getGrupoTemas = (state) => state.grupoTema.lista
export const getIsCarregandoListaGrupoTemas = (state) => state.grupoTema.isCarregandoLista
export const getIsSavingGrupoTema = (state) => state.grupoTema.isSaving
